import React from 'react';
import Alert from '@mui/material/Alert';

export const VENDOR_SELECTION_STALE_MESSAGE =
  'Vendor selection changed after this section was written. Review and update this text before using it.';

const VendorSelectionStaleWarning: React.FC<{ testId?: string }> = ({ testId }) => (
  <Alert severity="warning" data-testid={testId} sx={{ mb: 1.5 }}>
    {VENDOR_SELECTION_STALE_MESSAGE}
  </Alert>
);

export default VendorSelectionStaleWarning;
